import { ValidationErrorMessages } from '@constants/forms';
import { BroadbandFormValues } from '@src/types/broadband';
import { BooleanSelection } from '@src/types/index';
import { validateGBLandlineNumber } from '@utils/validators';

import { FormErrors } from './types';

type ValidateOptions = {
  showDigitalHomePhone?: boolean;
};

const validate = (
  {
    selectedTariff,
    landline,
    callPackage,
    callPackageId,
    includeVoip,
  }: BroadbandFormValues,
  { showDigitalHomePhone = false }: ValidateOptions = {}
) => {
  const errors: FormErrors = {};
  if (!selectedTariff) {
    errors.selectedTariff = ValidationErrorMessages.FIELD_REQUIRED;
  }

  if (showDigitalHomePhone && !includeVoip) {
    errors.includeVoip = ValidationErrorMessages.FIELD_REQUIRED;
  }

  const voipExcluded =
    showDigitalHomePhone && includeVoip === BooleanSelection.No;

  const isValidLandline =
    voipExcluded || !landline || validateGBLandlineNumber(landline);
  if (!isValidLandline) {
    errors.landline = ValidationErrorMessages.INVALID_PHONE;
  }

  if (!voipExcluded && callPackage === BooleanSelection.Yes && !callPackageId) {
    errors.callPackageId = ValidationErrorMessages.FIELD_REQUIRED;
  }

  return errors;
};

export { validate };
